import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { formatDate } from "utils/date";

import ExternalLinkIcon from "assets/external-link-icon.inline.svg";
import { BodyText, HeadingText, Section } from "styles";

import { FeaturedPostMeta } from "./FeaturedPost.styles";
import { ImageWrapper } from "./PostsGrid.styles";

type Props = {
  post: Queries.AllPostsQuery["allSanityPost"]["nodes"][0];
};

export const FeaturedPost = ({ post }: Props) => {
  const isExternal = post.isExternal && post.externalUrl;
  const postUrl = isExternal
    ? post.externalUrl
    : `/posts/${post.slug?.current}`;

  const image = post?.image?.asset ? getImage(post.image.asset) : null;
  const LinkComponent = isExternal ? "a" : Link;
  return (
    <Section className="mb-20 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      <LinkComponent
        //@ts-ignore
        to={isExternal ? undefined : postUrl}
        href={isExternal ? postUrl : undefined}
        target={isExternal ? "_blank" : undefined}
        className="flex lg:col-span-2"
      >
        {image && (
          <ImageWrapper>
            <GatsbyImage
              className="h-full w-full rounded-lg object-cover"
              image={image}
              alt={post.title || "image"}
            />
          </ImageWrapper>
        )}
      </LinkComponent>
      <FeaturedPostMeta className="rounded-lg p-6">
        <div className="flex flex-col items-end">
          <BodyText as="div" $variant="b5reg">
            {formatDate(post.date)}
          </BodyText>
          <BodyText as="div" $variant="b5reg">
            {post.author}
          </BodyText>
          {isExternal && (
            <a href={post.externalUrl}>
              <BodyText as="div" $variant="b5reg" className="flex gap-x-2">
                External <ExternalLinkIcon />
              </BodyText>
            </a>
          )}
        </div>
        <Link to={postUrl}>
          <HeadingText $variant="heading03">{post.title}</HeadingText>
          <BodyText $hasPadding={false} $variant="b3reg">
            {post.subtitle}
          </BodyText>
        </Link>
      </FeaturedPostMeta>
    </Section>
  );
};
